import React, { Component } from 'react';
import {Collapse, Modal, ModalBody, ModalFooter} from 'reactstrap';
import Select from 'react-select';
import {api} from '../../api';
import Header from '../../general/navigation/Header';
import Loading from '../../general/components/Loading.js';
import RichTextEditor from '../../general/text-editor/RichTextEditor';
import { handleRichTextInput } from '../../utils/ConvertDraftToTiptap';

export default class WorkPermitOutput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      countryId: localStorage.getItem('countryId'),
      isLoading: true,
      whitelistedUrls: [],
      blockedUrls: [],
      isRemoveSectionModalOpen: false,
      regionId: localStorage.getItem('regionId'),
      sections: [],
      sectionToDeleteId: null,
      country: null,
      region: null,
      selectedWorkPermit: null,
      workPermits: [],
      isSectionValid: true,
      sectionUrlValidity: [],
      invalidSectionUrls: [],
    };
  }

  componentDidMount() {
    if (!this.state.regionId || !this.state.countryId) {
      window.location.replace('/#/');
    } else{
      this.fetchCountryData();
      if (this.state.whitelistedUrls.length === 0) {
        this.fetchWhitelistedUrls();
      }
    }
  }

  async fetchWhitelistedUrls() {
    await api.get('/whitelist').then((res) => this.setState({ whitelistedUrls: res.data }));
  }

  async fetchCountryData() {
    const countriesResponse = await api.get(`/countries/${localStorage.getItem('countryId')}`);
    const region = countriesResponse.data.regions.find(regionToFind => regionToFind.id === parseInt(localStorage.getItem('regionId')));

    this.setState({
      country: countriesResponse.data,
      region
    }, () => this.fetchWorkPermitData());
  }

  async fetchWorkPermitData() {
    const workPermitsResponse = await api.get(`/countries/${localStorage.getItem('countryId')}/regions/${localStorage.getItem('regionId')}/work-permits`);
    const workPermitOptions = [];

    workPermitsResponse.data.forEach(workPermit => {
      workPermitOptions.push({
        value: workPermit,
        label: (workPermit.workPermitRevisions[0].name + (workPermit.workPermitRevisions[0].deloittePermitId && " - "+ workPermit.workPermitRevisions[0].deloittePermitId)),
      });
    });

    this.setState({
      isLoading: false,
      workPermits: workPermitOptions
    });
  }

  async fetchSections() {
    const recruiterOutputResponse = await api.get(`/work-permits/${this.state.selectedWorkPermit.id}/recruiter-output`);
    const sections = [];

    if (recruiterOutputResponse.data.sections) {
      recruiterOutputResponse.data.sections.forEach(section => {
        sections.push({
          id: section.id,
          staticTitle: section.title,
          title: section.title,
          content: handleRichTextInput(section.content),
          isCollapseOpen: false,
          isSectionDirty: false,
        })
      });
    }

    this.setState({
      isLoading: false,
      sections: sections,
      recruiterOutputId: recruiterOutputResponse.data.id,
      sectionUrlValidity: sections.map(() => true),
      invalidSectionUrls: sections.map(() => '')
    });
  }

  handleWorkPermitSelect = (event) => {
    this.setState({
       sections: [],
    });
    const workPermit = event.value;
    this.setState({
      selectedWorkPermit: workPermit
    }, async () => await this.fetchSections());
  }

  toggleCollapse = (index) => {
    const {sections} = this.state;

    sections[index].isCollapseOpen = !sections[index].isCollapseOpen;
    this.setState({sections});
  }

  handleSectionTitle = (event, index) => {
    const {sections} = this.state;

    sections[index][event.target.name] = event.target.value;
    sections[index].isSectionDirty = true;
    this.setState({sections});
  }

  handleRichTextFormatInput = (section, index, editorText) => {
    const {sections} = this.state;
    let sectionToEdit = sections.find(stateSection => stateSection.content === section.content);
    sectionToEdit.content = handleRichTextInput(JSON.stringify(editorText));
    sectionToEdit.isSectionDirty = true;

    // Validate content and update per-section validity
    let foundInvalidUrl = "";
    const validity = this.isContentValid(sectionToEdit.content.content, url => { foundInvalidUrl = url; });
    const newValidity = [...this.state.sectionUrlValidity];
    newValidity[index] = validity;

    // Set invalid URL for this section
    const newInvalidSectionUrls = [...this.state.invalidSectionUrls];
    newInvalidSectionUrls[index] = foundInvalidUrl;

    this.setState({
      sectionUrlValidity: newValidity,
      invalidSectionUrls: newInvalidSectionUrls,
      isSectionValid: newValidity.every(Boolean)
    });

  }

  addSection = () => {
    const { sections, invalidSectionUrls, sectionUrlValidity } = this.state;

    sections.push({
      staticTitle: 'Enter a  title below',
      title: '',
      content: '',
      isCollapseOpen: true,
      isSectionDirty: true,
    });

    const newInvalidSectionUrls = [...invalidSectionUrls, ''];
    const newSectionUrlValidity = [...sectionUrlValidity, true];
    this.setState({
      sections,
      invalidSectionUrls: newInvalidSectionUrls,
      sectionUrlValidity: newSectionUrlValidity,
    });
  }

  onClickSave = () => {
    this.setState({isLoading: true}, () => this.saveChanges());
    console.log(this.state.selectedWorkPermit.workPermitRevisions[0].deloittePermitId)
  }

  async saveChanges() {
    if(this.isWorkPermitOutputValid()){
      for (const section of this.state.sections) {
        if (section.isSectionDirty) {
          const sectionToPost = {
            title: section.title,
            content: JSON.stringify(section.content)
          };

          if (section.id) {
            await api.patch(`/work-permits/${this.state.selectedWorkPermit.id}/recruiter-output/${this.state.recruiterOutputId}/sections/${section.id}`, sectionToPost).then(() => {});
          } else {
            await api.post(`/work-permits/${this.state.selectedWorkPermit.id}/recruiter-output/${this.state.recruiterOutputId}/sections`, sectionToPost).then(() => {});
          }
        }
      }

      await this.fetchSections();
    }
  }

  handleRemoveSectionClick = (section, index) => {
    if (section.id) {
      this.setState({
        sectionToDeleteId: section.id,
        isRemoveSectionModalOpen: true,
      });
    } else {
      const newInvalidSectionUrls = this.state.invalidSectionUrls.filter((_, i) => i !== index);
      const newSectionUrlValidity = this.state.sectionUrlValidity.filter((_, i) => i !== index);
      const { sections } = this.state;
      sections.splice(index, 1);
      this.setState({
        sections,
        invalidSectionUrls: newInvalidSectionUrls,
        sectionUrlValidity: newSectionUrlValidity,
      });
    }
  }

  removeSection = (index) => {
    this.setState({isLoading: true}, () => {
      api.delete(`/work-permits/${this.state.selectedWorkPermit.id}/recruiter-output/${this.state.recruiterOutputId}/sections/${this.state.sectionToDeleteId}`)
        .then(() => {
          this.toggleModal();
          this.setState({sectionToDeleteId: null})
          this.fetchSections();
        });
    });
  }

  toggleModal = () => {
    this.setState(prevState => ({
      isRemoveSectionModalOpen: !prevState.isRemoveSectionModalOpen,
    }));
  }

  isContentValid = (content, setInvalidUrlCb = null) => {
    if (!content) return false;
    for (const element of content) {
      switch (element.type) {
        case "text":
          if (element.text.includes("<") || element.text.includes(">"))
            return false;
          if (element.marks) {
            const contentValid = this.isContentValid(element.marks,setInvalidUrlCb);
            if (!contentValid) return false;
          }
          break;
        case "link":
          if (!this.state.whitelistedUrls.includes(element.attrs.href)) {
            if (typeof setInvalidUrlCb === "function") {
              setInvalidUrlCb(element.attrs.href);
            } else {
              this.setInvalidUrl(element.attrs.href); // <-- Set global invalidUrl if no callback
            }
            return false;
          }
          break;
        default:
          const contentValid = element.content ? this.isContentValid(element.content, setInvalidUrlCb) : true;
          if (!contentValid) return false;
          continue;
      }
    }
    return true;
  }

  isWorkPermitOutputValid() {
    if (this.state.sections.length === 0 || !this.state.isSectionValid)  return false;

    const hasDirtySections = this.state.sections.some(section =>
      section.isSectionDirty && section.content );

   return hasDirtySections
  }


  render() {
    return (
      this.state.isLoading ?
        <Loading />
        :
        <React.Fragment>
          <Header showClientNavigation ={false} showImmigrationNavigation={true} displayName={this.state.country.name + (this.state.country.regions.length > 1 ? " - " + this.state.region.name : "")} link={"/select-country"}/>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="gw__section-headings">Work Permit Output</h3>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-6">
                <p className="">
                  In addition to the visa, work permit, stay duration and processing time range we will also supply the recruiter with the following information to aid
                  the candidate's transition to a  country.
                </p>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-6">
                <label className="output-label">Work Permit</label>
                <Select options={this.state.workPermits} onChange={this.handleWorkPermitSelect} />
              </div>
            </div>
            {
              this.state.selectedWorkPermit && this.state.sections && 
              <React.Fragment>
                <div className="row mt-4">
                  {
                    this.state.sections.map((section, index) => {
                      return (
                        <div key={index} className="col-sm-12">
                          <hr className="mt-4" />
                          <div className="d-flex justify-content-between align-items-center" onClick={() => this.toggleCollapse(index)}>
                            <div className="output-section-header">{section.staticTitle}</div>
                            <div className="chevron"></div>
                          </div>
                          <Collapse className="mt-4 collapse-menu-item" isOpen={this.state.sections[index].isCollapseOpen}>
                            <label>Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              maxLength={255}
                              value={this.state.sections[index].title}
                              onChange={(event) => this.handleSectionTitle(event, index)}
                              placeholder="Please enter a title for the section"
                            />

                        <RichTextEditor content={section.content} onContentChange={(editorText) => this.handleRichTextFormatInput(section, index, editorText)} />
                        {/*}<RichTextEditor section={section} handleRichTextFormatInput={this.handleRichTextFormatInput} />*/}
                        {!this.state.sectionUrlValidity[index] && this.state.invalidSectionUrls[index] !== '' && (
                            <p className="gw__invalid-name">
                              INVALID URL {this.state.invalidSectionUrls[index]} FOR THE SECTION
                            </p>
                        )}
                            <button className="btn btn-danger mt-4" onClick={() => this.handleRemoveSectionClick(section, index)}>Remove Section</button>
                          </Collapse>
                        </div>
                      )
                    })
                  }
                </div>
                <div className="row mt-4">
                  <div className="col-sm-12">
                    <button type="button" className="btn btn-secondary" onClick={this.addSection}>Add Section</button>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-12">
                    <button disabled={!this.isWorkPermitOutputValid()} type="button" className="btn btn-primary" onClick={this.onClickSave}>Save Changes</button>
                  </div>
                </div>
              </React.Fragment>
            }
          </div>
          <Modal isOpen={this.state.isRemoveSectionModalOpen} toggle={this.toggleModal} className={this.props.className}>
            <ModalBody>
              Are you sure you want to remove this section?
            </ModalBody>
            <ModalFooter>
              <button type="button" className="btn btn-secondary" onClick={this.toggleModal}>Close</button>
              <button type="button" className="btn btn-danger" onClick={this.removeSection}>Remove</button>
            </ModalFooter>
          </Modal>
        </React.Fragment>
    )
  }
}
